import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { API_BASE_URL } from '../config/api';

const TermsConditions = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/legal/policy/terms?platform=website`);
        if (response.ok) {
          const data = await response.json();
          setContent(data);
        } else {
          setError('Failed to load terms and conditions');
        }
      } catch (err) {
        setError('Failed to load terms and conditions');
      } finally {
        setLoading(false);
      }
    };
    fetchPolicy();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen pt-24 pb-16 flex items-center justify-center">
        <div className="text-warm-textSub">Loading...</div>
      </div>
    );
  }

  if (error || !content) {
    return (
      <div className="min-h-screen pt-24 pb-16 flex items-center justify-center">
        <div className="text-warm-textMuted">{error || 'Terms and conditions not available'}</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-24 pb-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl font-bold text-warm-text mb-4">{content.heading}</h1>
          <p className="text-warm-textMuted mb-8">Version: {content.version}</p>

          <div
            className="prose max-w-none legal-content"
            dangerouslySetInnerHTML={{ __html: content.contents }}
          />
        </motion.div>
      </div>
    </div>
  );
};

export default TermsConditions;
